module.exports = __webpack_public_path__ + "static/media/box_clock.a41e9335.webp";